import React from "react";
import { Grid2 } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
// styles
import styles from "./AddonIcons.module.scss";

export default function AddonIcons({ icon: Icon, tooltipText }) {
  return (
    <Tooltip
      title={tooltipText}
      arrow
      placement="bottom"
      style={{ cursor: "pointer" }}
    >
      <Grid2 className={styles.AddonIconsCard}>
        <Grid2 className={styles.iconBox}>
          <Icon className={styles.icon} />
        </Grid2>
      </Grid2>
    </Tooltip>
  );
}
